import React, { Component } from 'react';
import { BeatLoader as Loader } from 'react-spinners';

class Loading extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center', margin: '150px 0 150px 0' }}>
        <Loader color="#0eb2ff" />
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js